import { takeEvery, put, call } from 'redux-saga/effects';

import { URL_API } from '../../common/constants/common.js';
import { HttpConnection } from '../../common/helper/http-connection.js'
import { loginCheck, maintenanceCheck } from '../../common/helper/commonHelper.js';

function* getUserList(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/getUserList',
        parameter: {
            search: action.search,
            type: action.userType,
            course: action.course
        },
    }
    const data = yield call(http.post, info);
    if(data.statusCode === 200){
        if(action.onSuccess) {
            action.onSuccess(data.items);
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "getUserList",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const getUserListSaga = takeEvery('GetUserList_Saga', getUserList);

function* setUser(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/setUser',
        parameter: {
            id: action.id,
            address: action.address,
            password: action.password,
            type: action.userType,
            permission: action.permission,
            course: action.course,
            availableLimitedSubjectSet: action.availableLimitedSubjectSet,
            limitedSubjectSetEndDate: action.limitedSubjectSetEndDate,
            nickname: action.nickname,
            subscribeDate: action.subscribeDate,
            paymentDate: action.paymentDate,
            unsubscribeDate: action.unsubscribeDate,
            recessStartDate: action.recessStartDate,
            recessEndDate: action.recessEndDate,
            activateDate: action.activateDate,
            shadowingSendTwice: action.shadowingSendTwice,
            updateCourse: action.updateCourse,
            updateCourseDate: action.updateCourseDate,
        },
    }
    const data = yield call(http.post, info);
    if(data.statusCode === 200){
        if(action.onSuccess) {
            action.onSuccess();
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "setUser",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const setUserSaga = takeEvery('SetUser_Saga', setUser);

function* deleteUser(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/deleteUser',
        parameter: {
            id: action.id,
        },
    }
    const data = yield call(http.post, info);
    if(data.statusCode === 200){
        if(action.onSuccess) {
            action.onSuccess(action.index);
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "deleteUser",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const deleteUserSaga = takeEvery('DeleteUser_Saga', deleteUser);

function* restoreUser(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/restoreUser',
        parameter: {
            id: action.id,
        },
    }
    const data = yield call(http.post, info);
    if(data.statusCode === 200){
        if(action.onSuccess) {
            action.onSuccess();
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "restoreUser",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const restoreUserSaga = takeEvery('RestoreUser_Saga', restoreUser);

function* importUsers(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/getSheetData',
        parameter: {
            sheet: action.sheet,
            range: action.range,
        },
    }
    const data = yield call(http.post, info);

    yield put({
        type: "LoadEnd",
    });
    if(data.statusCode === 200){
        if(action.onSuccess) {
            action.onSuccess(data.count);
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "importUsers",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const importUsersSaga = takeEvery('ImportUsers_Saga', importUsers);

function* getSendCount(action) {
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/getSendCount',
        parameter: {
            userID: action.id,
            month: action.month,
            course: action.course
        },
    }
    const data = yield call(http.post, info);

    if(data.statusCode === 200){
        yield put({
            type: "SetSendCount",
            sendCount: data.count,
        });
        if(action.onSuccess) {
            action.onSuccess(action.index, data.count);
        }
    } else {
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const getSendCountSaga = takeEvery('GetSendCount_Saga', getSendCount);

function* getShadowingSend(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);

    let http = new HttpConnection();
    let info = {
        url: URL_API + '/getShadowingSend',
        parameter: {
            userID: action.userID,
        },
    }
    const data = yield call(http.post, info);

    if(data.statusCode === 200){
        if(action.onSuccess) {
            action.onSuccess(data.shadowingSendFlag);
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "getShadowingSend",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const getShadowingSendSaga = takeEvery('GetShadowingSend_Saga', getShadowingSend);
